import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import jaLang from 'element-ui/lib/locale/lang/ja';
import locale from 'element-ui/lib/locale';
import messages from '@/locales';

locale.use(jaLang);

Vue.use(VueI18n);

const silenceWarning = process.env.VUE_APP_ENV === 'test' || process.env.NODE_ENV === 'production';

const dateTimeFormats = {
  en: {
    numeric: {
      month: 'numeric', day: 'numeric'
    },
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    time: {
      hour: 'numeric', minute: 'numeric'
    }
  },
  ja: {
    numeric: {
      month: 'numeric', day: 'numeric'
    },
    numericutc: {
      month: 'numeric', day: 'numeric', timeZone: 'GMT'
    },
    short: {
      month: 'short', day: 'numeric'
    },
    datetime: {
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      ampm: false
    },
    datetimeutc: {
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      ampm: false,
      timeZone: 'GMT'
    },
    medium: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    mediumutc: {
      year: 'numeric', month: 'short', day: 'numeric', timeZone: 'GMT'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    // To avoid GMT time adjustment(+9hr)
    longutc: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: 'UTC'
    },
    time: {
      hour: '2-digit', minute: '2-digit', hour12: false, ampm: false
    },
    timeutc: {
      hour: '2-digit', minute: '2-digit', hour12: false, ampm: false, timeZone: 'GMT'
    }
  }
};

export const i18n = new VueI18n({
  dateTimeFormats,
  messages,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ja',
  locale: process.env.VUE_APP_I18N_LOCALE || 'ja',
  silentTranslationWarn: silenceWarning
});

export default i18n;
